import React from 'react';
import Person from '../components/Person';

const PeoplePage = () => (
    <React.Fragment>
        <h2 className="page-heading">People</h2>
        <h4 className="team-title">Principal Investigator</h4>
        <Person name="Sidong" />
        <hr></hr>
        <h4 className="team-title">Graduate Students</h4>
        <Person name="Aisha"/>
        <Person name="Ningxin" />
        <Person name="Diren" />
        <Person name="Tara" />
        <hr></hr>
        <h4 className="team-title">Undergraduate Students</h4>
        <Person name="Alexander" />
        <Person name="Williams" />
        <Person name="Sosebee" />
        <Person name="Sherif" />
        <hr></hr>
        <h4 className="team-title">Alumni</h4>
        <Person name="Aditya" />
        <Person name="Brian" />
        <hr></hr>
        
    </React.Fragment>
    
)

export default PeoplePage;